/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { colors, fonts, mixins } from '@blend/consumer-components';

const toggleWidth = 50;
const toggleHeight = 20;
const borderSize = 2;
const transitionDuration = '0.3s';

export const createStyles = (color: string) => {
  const toggleSwitchSize = toggleHeight - borderSize * 2;

  return StyleSheet.create({
    toggle: {
      ...mixins.globalBorderStyle,
      padding: 14,
    },
    noBorder: {
      borderWidth: 0,
      padding: 8,
    },
    indicator: {
      width: toggleWidth,
      height: toggleHeight,
      minWidth: toggleWidth,
      marginLeft: 'auto',
      backgroundColor: colors.clayPlus2,
      borderRadius: toggleHeight * 2,
      transition: transitionDuration,
      position: 'relative',
      boxShadow: mixins.boxShadow(0, 0, 1, 0, mixins.fade(colors.black, 0.15)),
      cursor: 'pointer',
      display: 'inline-block',

      // round toggle switch element
      ':after': {
        top: 2,
        left: 2,
        width: toggleSwitchSize,
        height: toggleSwitchSize,
        transition: transitionDuration,
        content: mixins.pseudoContent(''),
        position: 'absolute',
        background: colors.white,
        borderRadius: '100%',
        boxShadow: mixins.boxShadow(0, 0, 1, 0, mixins.fade(colors.black, 0.2)),
      },
    },
    checked: {
      backgroundColor: color,

      // move toggle switch over
      ':after': {
        left: 32,
      },
    },
    focused: mixins.mimicBrowserDefaultOutline(),
    icon: {
      fontWeight: fonts.weight.semibold,
      position: 'absolute',
      textAlign: 'right',
      color: colors.white,
      fontSize: 10,
      top: 2,
      left: 0,
    },
    yes: {
      right: 23,
    },
    no: {
      left: 22,
    },
  });
};
